import {useEffect} from 'react';
import {NOT_FOUND_PATH} from '@constants';
import {useNavigate} from 'react-router-dom';

export default function NotFoundRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(`${NOT_FOUND_PATH}/recipient`, {replace: true});
    }, [navigate]);

    return null;
}
